export default __webpack_public_path__ + "static/Efficiency-bbc835ae1dbe0f108175a725cedc3ce2.gif";